module.exports = __webpack_public_path__ + "static/alfa-energia-720a20b195493e417e76fa71e1f9e6a4.png";